import apiClient from "./apiClient";
import config from "../config/api";

const login = (email, password) => {
    return apiClient.post(config.ENDPOINTS.AUTH, {email: email, password: password});
}

export default {
    login,
};